import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { emit, subscribe, unsubscribe } from 'helpers/global-events';
import ApiError from 'errors/apiError';
import apiDecorator from 'api/api-decorator';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import localStorage from 'helpers/local-storage';
import Checkbox from 'containers/form/input-checkbox';
import Button from 'components/button';
import { authConnect, UserProp } from 'auth';

import translates from './notifications-i18n.json';

const bemClasses = new Bem('subscribe');

/**
 * Component for subscribe/unsubscribe
 */
@authConnect()
@apiDecorator
@I18nHoc(translates)
export default class Subscribe extends PureComponent {
  static propTypes = {
    /** Subscription type */
    type: PropTypes.string.isRequired,
    /** Subscription entity */
    entity: PropTypes.string.isRequired,
    /** Subscription entity id */
    entity_id: PropTypes.number.isRequired,
    /**
     * If active - render as button, and user must push it to subscribe
     * If passive - render as checkbox, and manualy action call needed,
     * typically - handler on onSubmit
     */
    mode: PropTypes.oneOf(['active', 'passive']).isRequired,
    /**
     * Default checkbox state for "subscribe" status in passive mode
     */
    passiveDefaultSubscribe: PropTypes.bool,
    labelSubscribe: PropTypes.string,
    labelUnsubscribe: PropTypes.string,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
  };

  static defaultProps = {
    passiveDefaultSubscribe: true
  };

  constructor(props, ctx) {
    super(props, ctx);
    // For passiveDefaultSubscribe behavior
    // If passiveDefaultSubscribe is true - user has "subscribe" is checked by default.
    // But if user manually check subscribe to off - we must save this state, and
    // do not set subscribe is on by default
    this.defaultSubscribeState = false;
    if (props.mode === 'passive') {
      this.defaultSubscribeState =
        localStorage.get('noSubscribe') == '1' ? false : props.passiveDefaultSubscribe;
    }

    this.state = {
      requested: false,
      checked: this.defaultSubscribeState,
      status: null // subscribed/unsubscribed
    };
    this.doAction = this.doAction.bind(this);
  }

  componentDidMount() {
    if (this.props.auth && this.props.auth.authenticated) {
      this.checkStatus();
    }

    if (this.props.updateEvent) {
      subscribe(this.props.updateEvent, this.timeoutCheckStatus);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.auth &&
      prevProps.auth &&
      this.props.auth.authenticated &&
      !prevProps.auth.authenticated) {
      this.checkStatus();
    }
  }

  componentWillUnmount() {
    if (this.props.updateEvent) {
      unsubscribe(this.props.updateEvent, this.timeoutCheckStatus);
    }
    clearTimeout(this.delay);
  }

  _query(action) {
    this.api.get(`/action/notifications/actions-subscription/${action}`, {
      queryString: {
        type: this.props.type,
        entity: this.props.entity,
        entity_id: this.props.entity_id,
        project: __PROJECT__
      }
    }).then(payload => this.setState({
      requested: true,
      status: payload.status,
      checked: payload.status === 'subscribed' ? true : this.defaultSubscribeState
    })).catch((error) => {
      throw new ApiError(error, {
        component: 'NotificationSubscripe',
        type: this.props.type,
        entity: this.props.entity,
        entity_id: this.props.entity_id
      });
    });
  }

  _handleCheckboxCheck = (val) => {
    const { auth, actionDoLogin } = this.props;

    if (!auth.authenticated) return actionDoLogin();

    this.setState({ checked: val });
    emit('toggleSubscribe');
    if (this.props.mode === 'passive') {
      localStorage.put('noSubscribe', val == false ? '1' : '0');
    }
  }

  /**
   * Manual subscribe/unsubscribe
   * for passive mode. Depends on checkbox state
   */
  doAction() {
    if (this.state.checked) {
      this._query('subscribe');
    } else {
      this._query('unsubscribe');
    }
  }

  checkStatus = () => {
    this._query('subscribe-status');
  }

  timeoutCheckStatus = () => {
    this.delay = setTimeout(() => this._query('subscribe-status'), 1000);
  }

  switchSubscribe = () => {
    const { auth, actionDoLogin } = this.props;

    if (!auth.id) return actionDoLogin();

    const { status } = this.state;
    emit('toggleSubscribe');
    this._query(status === 'subscribed' ? 'unsubscribe' : 'subscribe');
  }

  renderCheckbox() {
    const { i18n } = this;
    const { status, checked } = this.state;
    const { className, labelSubscribe, labelUnsubscribe } = this.props;
    const textSubscribe = labelSubscribe || i18n('subscribe');
    const textUnsubscribe = labelUnsubscribe || i18n('unsubscribe');

    return (
      <Checkbox
        {...bemClasses({ extra: className })}
        onChange={this._handleCheckboxCheck}
        value={checked}
        withIcon
        noError
      >
        {/*status === 'subscribed' ? labelUnsubscribe : labelSubscribe DEPRECATED*/}
        {textSubscribe}
      </Checkbox>
    );
  }

  renderButton() {
    const { i18n } = this;
    const { status } = this.state;

    // if (!status) return null;

    const { className, labelSubscribe, labelUnsubscribe } = this.props;
    const textSubscribe = labelSubscribe || i18n('subscribe');
    const textUnsubscribe = labelUnsubscribe || i18n('unsubscribe');
    const mods = status === 'subscribed' ? 'on' : 'off';
    const text = status === 'subscribed' ? textUnsubscribe : textSubscribe;

    return (
      <Button
        {...bemClasses({ modifiers: mods, extra: className })}
        onClick={this.switchSubscribe}
        label={text}
        title={text}
      />
    );
  }

  render() {
    // if (!this.state.requested) return null;

    const { mode } = this.props;

    switch (mode) {
      case 'active':
        return this.renderButton();
      case 'passive':
        return this.renderCheckbox();
      default:
        return null;
    }
  }
}
